import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  CampaignContentDataSources,
  CampaignContentDataSourcesVariables
} from './__generated__/CampaignContentDataSources';

const CAMPAIGN_CONTENT_DATA_SOURCES = gql`
  query CampaignContentDataSources($campaignId: ID!) {
    campaignContentDataSources(campaignId: $campaignId) {
      id
      name
      path
      logoUrl
      dataSourceType
    }
  }
`;

export const useCampaignContentDataSources = () => {
  return useLazyQuery<CampaignContentDataSources, CampaignContentDataSourcesVariables>(CAMPAIGN_CONTENT_DATA_SOURCES, {
    client: kmsClient
  });
};
